import React from 'react'
import { useTranslation } from 'react-i18next'
import { useInsightContentData } from 'hooks/useInsightModalState'
import { CountTypeStrings } from 'enums/CountType'
import { InsightContentSettingType } from 'components/insightContent/types'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { MeasureType, Sentiment } from 'enums'
import { getLabel } from 'utils/measureTypeUtil'
import { getPercentOfTotal } from 'components/insightContent/utils/utils'
import { PercentDisplay } from 'components/insightContent/visualization/Overview'
import SparklineOverview from 'components/insightContent/visualization/Overview/SparklineOverview'
import RunSearchEffect from './RunSearchEffect'

const NetSentiment = ({
  detailSetting,
  countType,
  timeUnits
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  timeUnits?: MetricTimeUnitStrings[]
}) => {
  const { t } = useTranslation()
  const insightContent = useInsightContentData(InsightContentType.NET_SENTIMENT)
  const insightCountInsightContent =
    insightContent?.data?.[0]?.results?.[0]?.data?.insights?.[0]?.dataset?.[0]?.set

  const positiveValue =
    insightCountInsightContent?.find((item: InsightData) => item?.name === Sentiment.POSITIVE)
      ?.value ?? 0
  const negativeValue =
    insightCountInsightContent?.find((item: InsightData) => item?.name === Sentiment.NEGATIVE)
      ?.value ?? 0

  const posPercent = getPercentOfTotal(positiveValue, positiveValue + negativeValue)
  const negPercent = getPercentOfTotal(negativeValue, positiveValue + negativeValue)

  return (
    <UnexpectedErrorBoundary>
      <RunSearchEffect detailSetting={detailSetting} countType={countType} timeUnits={timeUnits}>
        <SparklineOverview
          title={getLabel(MeasureType.NET_SENTIMENT)}
          customizedInfo={
            <PercentDisplay
              count={`${insightContent?.data?.[1].results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]}%`}
              sideLabel={
                posPercent !== undefined &&
                negPercent !== undefined &&
                t('sentimentPercentOfTotal', {
                  posPercent,
                  negPercent,
                  interpolation: { escapeValue: false }
                })
              }
            />
          }
          sparklineData={
            insightContent?.data?.[1].results?.[0]?.data?.metrics?.[1]?.dataset?.[0]?.set
          }
          measureType={MeasureType.NET_SENTIMENT}
          status={insightContent?.status}
        />
      </RunSearchEffect>
    </UnexpectedErrorBoundary>
  )
}

export default NetSentiment
